import React, { ReactNode } from "react"
import { Input, InputProps as MuiInputProps } from "@mui/material"
import { SxProps, Theme } from "@mui/material"

export type PrimitiveInputProps = {
	placeholder?: string
	disabled?: boolean
	fullWidth?: boolean
	name?: string
	onChange?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => Promise<void> | void
	type: "text" | "button" | "password" | "radio" | "number" | "file" | "checkbox" | "email"
	value?: string
	readonly?: boolean
	sx?: SxProps<Theme>
	showInputUnderline?: boolean
	startAdornment?: ReactNode
	endAdornment?: ReactNode
	className?: string
	inputProps?: React.InputHTMLAttributes<HTMLInputElement>
	InputProps?: Partial<Omit<MuiInputProps, "type"> & {
		inputProps?: React.InputHTMLAttributes<HTMLInputElement>
	}>
	id?: string
	size?: "small"
	minRows?: number
	multiline?: boolean
}

export const PrimitiveInput = React.forwardRef<HTMLInputElement, PrimitiveInputProps>(
	({ InputProps, inputProps, showInputUnderline, ...rest }, ref) => {
		return (
			<Input
				{...rest}
				inputRef={ref}
				inputProps={inputProps}
				disableUnderline={!showInputUnderline}
				{...InputProps}
			/>
		)
	}
)

PrimitiveInput.displayName = "PrimitiveInput"